import {
  SEND_PAYMENT_FAILED_MAIL
} from '@/store/actions.type';

import {getJWTFromStorage} from '@/api/localStorage'

export default {
  data () {
    return {
      ispaymentinfopresent: true,
	  paymentinfo: null
    }
  },

  created() {
    this.getPaymentInfo();
  },
  updated() {
	 if(this.ispaymentinfopresent){
		var userEmail = this.$store.state.authentication.user.email;
		var name = this.$store.state.authentication.user.name;
		var paymentFailObj = {};
		paymentFailObj.userEmail = userEmail;
		paymentFailObj.name = name.charAt(0).toUpperCase() + name.slice(1);
		
		this.$store.dispatch(SEND_PAYMENT_FAILED_MAIL, paymentFailObj);
	 }
  },
  methods: {
    getPaymentInfo () {
		var obj = getJWTFromStorage('paymentdata');
		this.paymentinfo = JSON.parse(obj).id;
		
		if (this.paymentinfo === undefined)
			this.ispaymentinfopresent = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/paymenterror.js